export default "__VITE_ASSET__CBITV20x__"